import Skeleton from 'react-loading-skeleton'
import { User } from '../../../../gql/graphql'
import { Fieldgroup } from '../../../_ui/forms'

type PropTypes = {
  loading?: boolean
  profile?: User
}

export const PersonalData = ({loading, profile}: PropTypes) => {
  const minToHMin = (minutes: number) => {
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;
    return h > 0 ? `${h}:${m} h` : `${m} min`;
  }

  return (
    <Fieldgroup label={'Persönliche Daten'}>
      <div className={'grid text-sm space-y-2 sm:space-y-0 sm:grid-cols-2 sm:gap-2'}>
        <div>
          <p className={'font-bold'}>Adresse</p>
          {!loading && profile?.street ? (
            <p>{profile.street}</p>
          ) : (
            <Skeleton height={16} width={100} style={{marginBottom: 4}} />
          )}
          {!loading && profile?.zip && profile?.city ? (
            <p>{profile.zip} {profile.city}</p>
          ) : (
            <Skeleton height={16} width={100} />
          )}
          {!loading && profile?.drivingDistance && profile?.drivingTime ? (
            <p className={'text-neutral-400'}>
              Anfahrt: {profile.drivingDistance > 10 ? Math.round(profile.drivingDistance) : profile.drivingDistance} km / {minToHMin(profile.drivingTime)}
            </p>
          ) : (
            <Skeleton height={16} width={100} />
          )}
        </div>
        <div>
          <p className={'font-bold'}>Kontakt</p>
          {profile?.email ? (
            <p>{profile.email}</p>
          ) : (
            <Skeleton height={16} width={100} style={{marginBottom: 4}} />
          )}
          {profile?.phone && (
            <p>{profile?.phone}</p>
          )}
        </div>
      </div>
    </Fieldgroup>
  )
}
